<template>
  <div>
    <v-list-tile
      v-for="(item, index) in data"
      :key="index"
    >
      <v-list-tile-content>
        <v-list-tile-title>
          {{ item.label }}
        </v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-list-tile-action-text>
          {{ item.value | digitGrouping(trun=true) }}
        </v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
export default {
  name: 'fact-sheet-generalinfo',
  props: ['data']
}
</script>
<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/FactSheet_GeneralInfo.vue